module.exports = __webpack_public_path__ + "static/media/music-hip-hop.cfa31905.png";